<div class="order-item-container">
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="type">نوع:‌ {{ getType() }}</div>
    <div class="price">
      <div class="span" *ngIf="+orderObject.price !== 0">
        {{ orderObject.price | digitsEnToFa }} تومان
      </div>
    </div>

    <div class="select">
      <mat-checkbox
        (click)="toggleSelect()"
        labelPosition="before"
        [checked]="!!orderObject.selected"
        [disabled]="!isSelectable"
      >
        انتخاب</mat-checkbox
      >
    </div>
  </div>

  <div class="content" *ngIf="orderObject.type !== 'thesis-edit'">
    <div
      class="information"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div class="info">
        <section class="print-type">{{ getPrintType() }}/</section>
        <section class="pages-number">
          {{ this.orderObject.pageCount + " صفحه" }}/
        </section>
        <section class="print-size">{{ getPrintSize() }}/</section>
        <section class="bw-pages-number">
          {{ getBwPagesCount() | digitsEnToFa }}
        </section>
        <section class="colorful-pages-number"></section>
        <section class="binding"></section>
        <section class="color"></section>
      </div>
      <div
        class="copies-number-controller"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <button
          matRipple
          class="increase"
          (click)="runAction('increaseCopy')"
          class="btn increase-btn"
        >
          +
        </button>
        <span class="printNumber">{{
          orderObject.copiesNumber | digitsEnToFa
        }}</span>
        <button
          (click)="runAction('decreaseCopy')"
          matRipple
          class="decrease"
          class="btn decrease-btn"
        >
          <jam-icon name="trash"></jam-icon>
        </button>
      </div>
    </div>
  </div>

  <div
    class="actions-status"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div class="status" [ngClass]="orderObject.status">
      {{ getDisplayStatus() }}
    </div>
    <button
      class="edit"
      mat-stroked-button
      [routerLink]="['/', 'print', 'edit', orderObject.id]"
      color="primary"
    >
      ویرایش
    </button>
  </div>
</div>
